<template>
	<div style="margin: 0 0 0 0;">
		<!-- Card -->
		<el-card class="box-card yhgl">
			<!-- Header -->
			<div slot="header">
				<el-row style="margin-bottom:20px">

					<!-- Title -->

          <el-col :span="12" style="text-align: right">
            <div style="line-height: 2.5rem; font-size: 1.5rem">
              在职用户管理
            </div>
          </el-col>
          <!-- Right -->
          <el-col :span="12" style="text-align: right">
            <el-button
                    v-if="isAuth('user:update')"
                    type="success"
                    style="display: inline"
                    @click="batchUpdate()"
            >批量修改</el-button
            >
            <el-button
              v-if="isAuth('user:add')"
              type="success"
              style="display: inline"
              @click="batchIn()"
              >批量导入</el-button
            >
            <el-button
              v-if="isAuth('user:add')"
              type="success"
              icon="el-icon-plus"
              style="display: inline"
              @click="showInsertUser()"
              >添加用户</el-button
            >
            <!-- <el-button type="info" icon="el-icon-sort" style="display: inline;">筛选条件</el-button> -->
          </el-col>
        </el-row>

        <el-form  :inline="true" :model="form" @keyup.enter.native="getUserList">
          <el-form-item label="大队">
            <el-select
              clearable
              :disabled="deptdisable"
              filterable
              @change="selectChanged2"
              v-model="form.dept"
              placeholder="请选择大队"
            >
              <el-option
                v-for="item in depts"
                :key="item.bmid"
                :label="item.bmmc"
                :value="item.bmid"
                :disabled="deptdisable"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="工号">
            <el-input
              @change="changeIndex"
              clearable
              placeholder="工号"
              v-model="form.username"
              clearable
              style="width: 120px"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="姓名">
            <el-input
              @change="changeIndex"
              placeholder="模糊查询用户名"
              v-model="form.name"
              prefix-icon="el-icon-user"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="岗位">
            <el-input
              @change="changeIndex"
              placeholder="模糊查询岗位"
              v-model="form.gw"
              prefix-icon="el-icon-user"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              style="margin-left: 1rem"
              @click="getUserList"
              >查询用户</el-button
            >
          </el-form-item>
          <el-collapse v-model="activeNames">
            <el-collapse-item title="更多条件" name="1">
              <el-row style="text-align: left">
                <el-form-item label="班组">
                  <el-select
                    clearable
                    :disabled="childdeptdisable"
                    v-model="form.childDept"
                    @change="changeIndex()"
                    placeholder="请选择班组"
                    clearable
                  >
                    <el-option
                      v-for="item in childDept"
                      :key="item.bmid"
                      :label="item.bmmc"
                      :value="item.bmid"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="职位">
                  <el-select
                    clearable
                    @change="changeIndex"
                    style="width: 100px"
                    v-model="form.zhiwei"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="list in dictionaryData.tzwxx"
                      :label="list.zwmc"
                      :value="list.zwid"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="年龄" prop="age">
                  <el-row>
                    <!--											<el-col :span="10">-->
                    <!--												<el-input  placeholder="年龄" v-model="form.minAge" clearable style="width: 100px">-->
                    <!--												-->
                    <!--											</el-input>-->
                    <el-input-number
                      @change="changeIndex"
                      v-model="form.minAge"
                      clearable
                      controls-position="right"
                      :min="0"
                      :max="500"
                      style="width: 100px"
                    ></el-input-number>
                    <!--											</el-col>-->

                    <!--											<el-col :span="2">-->
                    -
                    <!--											</el-col>-->
                    <!--											<el-col :span="10">-->
                    <!--												<el-input  placeholder="年龄" v-model="form.maxAge"  clearable style="width: 100px"></el-input>-->
                    <el-input-number
                      @change="changeIndex"
                      v-model="form.maxAge"
                      clearable
                      controls-position="right"
                      :min="0"
                      :max="500"
                      style="width: 100px"
                    ></el-input-number>
                    <!--											</el-col>-->
                  </el-row>
                </el-form-item>

                <el-form-item label="缴金性质">
                  <el-select
                    @change="changeIndex"
                    clearable
                    v-model="form.jiaojin"
                    placeholder="请选择"
                    style="width: 100px"
                  >
                    <el-option
                      v-for="list in dictionaryData.djjxz"
                      :label="list.mc"
                      :value="list.dm"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="来源">
                  <el-input
                    @change="changeIndex"
                    clearable
                    placeholder="来源"
                    v-model="form.from"
                    clearable
                    style="width: 100px"
                  >
                  </el-input>
                </el-form-item>

                <el-form-item label="性别">
                  <el-select
                    @change="changeIndex"
                    style="width: 100px"
                    clearable
                    v-model="form.sex"
                    placeholder="请选择性别"
                  >
                    <el-option label="男" value="1"></el-option>
                    <el-option label="女" value="2"></el-option>
                  </el-select>
                </el-form-item>
              </el-row>
              <el-row style="text-align: left">
                <el-form-item label="就业困难人员">
                  <el-select
                    @change="changeIndex"
                    style="width: 100px"
                    clearable
                    v-model="form.jyknry"
                    placeholder="就业困难人员"
                  >
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="身份证">
                  <el-input
                    @change="changeIndex"
                    clearable
                    placeholder="身份证号"
                    v-model="form.sfzhm"
                    clearable
                    style="width: 200px"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item label="加入公司日期">
                  <el-date-picker
                    v-model="jrgsrq"
                    type="daterange"
                    align="right"
                    unlink-panels
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-row>
            </el-collapse-item>
          </el-collapse>
        </el-form>
      </div>
      <!-- 添加用户模态框 -->
      <el-dialog
        :title="modal ? '添加用户信息' : '编辑用户信息'"
        :visible.sync="xzyhModal"
        width="80%"
        style="text-align: left">
        <el-form
          label-width="150px"
          ref="xzyh"
          :rules="insertRules"
          :model="xzyh"
          label-position="right"
          style="margin-right: 2rem"
        >
          <el-row>
            <el-col :span="16">
              <el-row>
                <el-col :span="8">
                  <el-form-item label="姓名" prop="xm">
                    <el-input v-model="xzyh.xm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="职员工号" prop="username">
                    <el-input v-model="xzyh.username"></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="性别" prop="xb">
                    <el-select
                      clearable
                      v-model="xzyh.xb"
                      placeholder=""
                      style="float: left"
                      disabled
                    >
                      <el-option label="男" value="1"></el-option>
                      <el-option label="女" value="2"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="15">
                  <el-form-item label="身份证号" prop="sfzhm">
                    <el-input v-model="xzyh.sfzhm"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="9">
                  <el-form-item label="出生日期" prop="csrq">
                    <el-input disabled v-model="xzyh.csrq"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="18">
                  <el-form-item label="证件地址" prop="zjdz">
                    <el-input v-model="xzyh.zjdz"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="是否计算工资" prop="sfjsgz">
                    <el-switch
                            v-model="xzyh.sfjsgz"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            :active-value="1"
                            :inactive-value="0"
                    >
                    </el-switch>
                </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="8" style="padding-left: 50px;">
              <div v-if="imageurl" class="txImage" @mouseenter="showButtons = true" @mouseleave="showButtons = false">
                <div class="deleteImg" v-if="showButtons">
                  <i class="el-icon-delete" style="cursor: pointer; font-size: 30px;"  @click="deleteButtonClicked()"></i>
                </div>
                <img id="userImage" :src="imageurl" />
              </div>
              <el-upload
                v-else
                class="avatar-uploader"
                action="#"
                :http-request="httpRequest"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageurl" :src="imageurl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="民族" prop="mz">
                <el-select
                  clearable
                  v-model="xzyh.mz"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.dmz"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退伍军人" prop="twjr">
                <el-select
                  clearable
                  v-model="xzyh.twjr"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="是否残疾人" prop="sfcjr">
                <el-select
                  clearable
                  v-model="xzyh.sfcjr"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工会会员" prop="ghhy">
                <el-select
                  v-model="xzyh.ghhy"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option label="是" value="1"></el-option>
                  <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="身高" prop="sg">
                <el-input v-model="xzyh.sg"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="手机号" prop="sjhm">
                <el-input v-model="xzyh.sjhm"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="文化程度" prop="whcd">
                <el-select
                  clearable
                  v-model="xzyh.whcd"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.dwhcd"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="6">
              <el-form-item label="就业困难人员" prop="jyknry">
                <el-select
                  v-model="xzyh.jyknry"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--						<el-col :span="4">-->
            <!--							<el-form-item label="政治面貌" prop="zzmm">-->
            <!--								<el-select v-model="xzyh.zzmm" placeholder="请选择" style="float: left;">-->
            <!--									<el-option v-for="list in dictionaryData.dzzmm" :label="list.mc" :value="list.dm"></el-option>-->
            <!--								</el-select>-->
            <!--							</el-form-item>-->
            <!--						</el-col>-->
            <!--						<el-col :span="6">-->
            <!--							<el-form-item label="培训情况" prop="pxqk">-->
            <!--								<el-select v-model="xzyh.pxqk" placeholder="请选择" style="float: left;">-->
            <!--									<el-option v-for="list in dictionaryData.dpxqk" :label="list.mc" :value="list.dm"></el-option>-->
            <!--								</el-select>-->
            <!--							</el-form-item>-->
            <!--						</el-col>-->
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="加入公司日期" prop="jrgsrq">
<!--                <el-input v-model="xzyh.jrgsrq"></el-input>-->
                <el-date-picker
                        style="width: 140px"
                        value-format="yyyy-MM-dd"
                        v-model="xzyh.jrgsrq"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="连续工龄(月)" prop="lxgl">
                <el-input disabled="true" v-model="xzyh.lxgl"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="加入本部日期" prop="jrbbrq">
                <el-input v-model="xzyh.jrbbrq"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="担任本职位日期" prop="drbzwrq">
                <el-input v-model="xzyh.drbzwrq"></el-input>
              </el-form-item>
            </el-col>
            <!--						<el-col :span="6">-->
            <!--							<el-form-item label="同步工资生效日期" prop="tbgzsxrq">-->
            <!--								<el-input v-model="xzyh.tbgzsxrq"></el-input>-->
            <!--							</el-form-item>-->
            <!--						</el-col>-->
          </el-row>
          <el-row>
            <el-col :span="6">

              <el-form-item  label="缴金性质" prop="jjxz">
                <el-select
                  clearable
                  v-model="xzyh.jjxz"
                  placeholder="请选择"
                  style="float: left;"
                >
                  <el-option
                    v-for="list in dictionaryData.djjxz"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>

<!--                  <el-form-item class="a1" v-if="xzyh.jjxz=='2'"  label="缴金性质" prop="jjxz" >-->
<!--                    <el-select-->
<!--                            clearable-->
<!--                            v-model="xzyh.jjxz"-->
<!--                            placeholder="请选择"-->
<!--                            style="float: left;">-->
<!--                      <el-option-->
<!--                              v-for="list in dictionaryData.djjxz"-->
<!--                              :label="list.mc"-->
<!--                              :value="list.dm"-->
<!--                      ></el-option>-->
<!--                    </el-select>-->
<!--                  </el-form-item>-->



            </el-col>
            <el-col :span="6">
              <el-form-item label="用工性质" prop="ygxz">
                <el-select
                  clearable
                  v-model="xzyh.ygxz"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.dygxz"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="就业性质" prop="jyxz">
                <el-select
                  clearable
                  v-model="xzyh.jyxz"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.djyxz"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="用户类型" prop="yhlx">
                <el-select
                  clearable
                  v-model="xzyh.yhlx"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.dyhlx"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="职位" prop="zw">
                <el-select
                  clearable
                  v-model="xzyh.zw"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.tzwxx"
                    :label="list.zwmc"
                    :value="list.zwid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="大队" prop="zzdyqc">
                <el-select
                  clearable
                  v-model="xzyh.zzdyqc"
                  @change="selectChanged"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="item in depts"
                    :key="item.bmid"
                    :label="item.bmmc"
                    :value="item.bmid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="班组" prop="ddbz">
                <el-select
                  clearable
                  v-model="xzyh.ddbz"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dddbz"
                    :label="list.bmmc"
                    :value="list.bmid"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="岗位">
<!--                <el-input v-model="xzyh.gw"></el-input>-->
                <!--<template v-if="!xzyh.gwid||xzyh.gwid==''">-->
                  <!--<el-select v-model="xzyh.gw" filterable placeholder="请选择岗位">-->
                    <!--<el-option-->
                            <!--v-for="item in gws"-->
                            <!--:key="item.ID"-->
                            <!--:label="item.GWMC"-->
                            <!--:value="item.GWMC">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                <!--</template>-->
                <template >
                <el-select v-model="xzyh.gwid" filterable placeholder="请选择岗位">
                  <el-option
                          v-for="item in gws"
                          :key="item.ID"
                          :label="item.GWMC"
                          :value="item.ID">
                  </el-option>
                </el-select>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row> </el-row>
          <el-row> </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="来源" prop="ly">
                <el-input
                  clearable
                  placeholder="来源"
                  v-model="xzyh.ly"
                  clearable
                  style="float: left"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="5">
              <el-form-item label="开户行" prop="khh">
                <el-input v-model="xzyh.khh"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="银行账号" prop="yhzh">
                <el-input v-model="xzyh.yhzh"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="公积金账号" prop="gjjzh">
                <el-input v-model="xzyh.gjjzh"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="居住地址" prop="jzdz">
                <el-input v-model="xzyh.jzdz"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="邮政编码" prop="yzbm">
                <el-input v-model="xzyh.yzbm"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row> </el-row>
          <!--					<el-row>-->
          <!--						<el-col :span="6">-->
          <!--							<el-form-item label="劳动合同签订日期" prop="ldhtqdrq">-->
          <!--								<el-input v-model="xzyh.ldhtqdrq"></el-input>-->
          <!--							</el-form-item>-->
          <!--						</el-col>-->
          <!--						<el-col :span="6">-->
          <!--							<el-form-item label="劳动合同起始日期" prop="ldhtqsrq">-->
          <!--								<el-input v-model="xzyh.ldhtqsrq"></el-input>-->
          <!--							</el-form-item>-->
          <!--						</el-col>-->
          <!--						<el-col :span="6">-->
          <!--							<el-form-item label="劳动合同截止日期" prop="ldhtjzrq">-->
          <!--								<el-input v-model="xzyh.ldhtjzrq"></el-input>-->
          <!--							</el-form-item>-->
          <!--						</el-col>-->
          <!--						<el-col :span="6">-->
          <!--							<el-form-item label="劳动合同期限" prop="ldhtqx">-->
          <!--								<el-input v-model="xzyh.ldhtqx"></el-input>-->
          <!--							</el-form-item>-->
          <!--						</el-col>-->
          <!--					</el-row>-->
          <el-row>
            <!--						<el-col :span="6">-->
            <!--							<el-form-item label="劳动合同工资" prop="ldhtgz">-->
            <!--								<el-input v-model="xzyh.ldhtgz"></el-input>-->
            <!--							</el-form-item>-->
            <!--						</el-col>-->
            <!--						<el-col :span="6">-->
            <!--							<el-form-item label="需补贴(月)" prop="xbty">-->
            <!--								<el-input v-model="xzyh.xbty"></el-input>-->
            <!--							</el-form-item>-->
            <!--						</el-col>-->
            <el-col :span="6">
              <el-form-item label="退工日期" prop="tgrq">
<!--                <el-input v-model="xzyh.tgrq"></el-input>-->
                <el-date-picker
                        style="width: 140px"
                        value-format="yyyy-MM-dd"
                        v-model="xzyh.tgrq"
                        type="date"
                        placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退工原因" prop="tgyy">
                <el-select
                  clearable
                  v-model="xzyh.tgyy"
                  placeholder="请选择"
                  style="float: left"
                >
                  <el-option
                    v-for="list in dictionaryData.dtgyy"
                    :label="list.mc"
                    :value="list.dm"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作电话" prop="workerPhone">
                <el-input v-model="xzyh.workerPhone"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工作短号" prop="workerSphone">
                <el-input v-model="xzyh.workerSphone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="bz">
                <el-input
                  type="textarea"
                  placeholder="请输入内容"
                  v-model="xzyh.bz"
                  maxlength="300"
                  show-word-limit
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="xzyhModal = false">取 消</el-button>
          <el-button type="primary" @click="modal ? xzyhxx() : bjyhxx()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- Content -->
      <el-table
        :data="userList"
        v-loading="loading"
        style="text-align: center; width: 100%"
        :header-cell-class-name="handleHeaderClass"
        @sort-change="handleTableSort"
      >
<!--        @header-click="handleHeaderCLick"-->
        <el-table-column prop="username" label="用户编号" sortable="custom"> </el-table-column>
        <el-table-column prop="xm" label="用户名">
          <template slot-scope="scope">
            <el-button type="text" @click="showUser(scope.row)">{{
              scope.row.xm
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="手机号码" prop="sjhm"> </el-table-column>
        <el-table-column label="部门" prop="zzdyqc" sortable="custom">
          <template slot-scope="scope" >
            <span>{{ getBm(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="岗位" sortable="custom" prop="gw">
          <!--					<template slot-scope="scope">-->
          <!--						<span v-for="list in zwxx" v-if="scope.row.zw==list.zwid" :value="list.zwmc">{{list.zwmc}}</span>-->
          <!--					</template>-->
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="240" :render-header="renderHeader">
          <template slot-scope="scope">
            <el-row>
              <el-col :span="2" v-if="isAuth('user:assess')">
                  <i
                    class="el-icon-s-claim"
                    title="年终考核"
                    @click.stop="getKhInfo(scope.row)"
                  ></i>

              </el-col>
              <el-col :span="2" v-if="isAuth('user:kinsfolk')">
                  <i title="亲属"
                    class="el-icon-s-custom"
                    @click.stop="getQsList(scope.row)"></i>

              </el-col>
              <el-col :span="2" v-if="isAuth('user:setrole')">

                  <i
                          title="角色"
                    class="el-icon-user-solid"
                    @click.stop="setRole(scope.row)"
                  ></i>

              </el-col>
              <el-col :span="3" v-if="isAuth('user:update')">

                  <i
                          title="修改"
                    class="el-icon-edit"
                    @click.stop="bjyhBefore(scope.row)"
                  ></i>
              </el-col>
              <el-col :span="3" v-if="isAuth('user:exception')">

                  <i
                          title="异常"
                    class="el-icon-warning"
                    @click.stop="setException(scope.row)"
                  ></i>
              </el-col>
              <el-col :span="3" v-if="isAuth('user:update')">

                <i
                        title="是否禁用PC登录"
                        :class="scope.row.islogin=='0'?'el-icon-circle-close':'el-icon-circle-check'"
                        @click.stop="setUserIsLogin(scope.row)"
                ></i>
              </el-col>
              <el-col :span="3" v-if="isAuth('user:update')">

                <i
                        title="黑名单"
                        class="element-icons el-iconblacklist"
                        @click.stop="setUserBlackList(scope.row)"
                ></i>
              </el-col>
              <el-col :span="3" v-if="isAuth('user:update')">

                  <i
                    class="el-icon-refresh-right"
                    title="重置密码"
                    @click.stop="resertPwd(scope.row)"
                  ></i>

              </el-col>
              <el-col :span="3" v-if="isAuth('user:delete')">

                  <i
                          title="删除"
                    class="el-icon-delete"
                    @click.stop="delUser(scope.row)"
                  ></i>

              </el-col>
            </el-row>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
                  style="text-align: left"
                  title="导出"
                  :visible.sync="exportVisible"
          >
            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            <el-checkbox-group v-model="fieldList" @change="handleCheckedItemChange">
              <el-checkbox v-for="field in fields" :label="field.value" :key="field.value">{{field.name}}</el-checkbox>
            </el-checkbox-group>
            <form ref="exportForm" method="post" :action="this.$request.defaults.baseURL+'/bjba/yhgl/exportExcel?access_token='+this.$store.getters.token"  target="_blank">
              <input type="hidden" v-for="(value,key,index) in form" :name="key"  :value="value" />
              <input type="hidden" name="fileds" value="" ref="fileds"/>
            </form>
            <span slot="footer" class="dialog-footer">
    <el-button @click="exportVisible = false">取 消</el-button>
    <el-button type="primary" @click="exportExcel">确 定</el-button>
  </span>
          </el-dialog>
      <!-- Page -->
      <el-pagination
        background
        layout="total, prev, pager, next"
        :current-page.sync="currentPage"
        :total="total"
        @current-change="pageUser"
        style="margin-top: 1rem"
      ></el-pagination>
      <set-role v-if="addOrUpdateVisible" ref="addOrUpdate"></set-role>
      <set-exception v-if="exceptionVisible" ref="exception" ></set-exception>
      <user-blacklist v-if="blacklistVisible" ref="blacklist" @refreshDataList="getUserList"></user-blacklist>
      <batch-in v-if="batchVisible" ref="batch"></batch-in>
    </el-card>
    <yhgl-dialog
      v-if="isOpen"
      ref="fetchTableData"
      @closepop ="closepop"
    ></yhgl-dialog>
    <nzkh-dialog v-if="isAsOpen" ref="fetchNzKhData" @closepop ="closepop"></nzkh-dialog>
  </div>
</template>

<script>
import Template from "../../../template";
import SetRole from "./setrole";
import SetException from "./setexception0";
import UserBlacklist from "./user-blacklist";
import BatchIn from "./bacth-in";
import YhglDialog from "./components/yhgl-dialog";
import NzkhDialog from "./components/nzkh-dialog";
const exportFields=[
  {value:"username",name:"职员代码"},
  {value:"xm",name:"姓名"},
  {value:"xb",name:"性别"},
  {value:"sfzhm",name:"身份证号码"},
  {value:"zjdz",name:"证件地址"},
  {value:"zzdyqc",name:"组织单元"},
  {value:"gw",name:"岗位"},
  {value:"jrgsrq",name:"加入公司日期"},
  {value:"bz",name:"备注"},
  {value:"jjxz",name:"缴金性质"},
  {value:"jyxz",name:"就业性质"},
  {value:"ly",name:"来源"},
  {value:"nl",name:"年龄"},
  {value:"pxqk",name:"培训情况"},
  {value:"twjr",name:"退伍军人"},
  {value:"mz",name:"民族"},
  {value:"whcd",name:"文化程度"},
  {value:"ygxz",name:"用工性质"},
  {value:"sjhm",name:"手机号码"},
  {value:"csrq",name:"出生日期"},
  {value:"yhlx",name:"员工类别"},
  {value:"drbzwrq",name:"担任本职位日期"},
  {value:"lxgl",name:"工龄"},
  {value:"zzmm",name:"政治面貌"},
  {value:"sg",name:"身高(cm)"},
  {value:"yhzh",name:"银行账号"},
  {value:"ghhy",name:"工会会员"},
  {value:"ddbz",name:"大队班组"},
  {value:"jrbbrq",name:"进入本部日期"},
  {value:"khh",name:"开户行"},
  {value:"jzdz",name:"居住地址"},
  {value:"workerPhone",name:"工作号码"},
  {value:"workerSphone",name:"工作短号"},
  {value:"sfjsgz",name:"是否计算工资"}
]
export default {
  components: { Template, SetRole, SetException, BatchIn, YhglDialog ,NzkhDialog,UserBlacklist },
  data() {
    return {
      gws:[],
      isAsOpen:false,
      isOpen: false,
      activeNames: [],
      loading: true, // 表格加载动画
      userList: [], // 用户列表
      currentPage: 1, // 当前页码
      total: 0, // 用户列表总数
      username: "", // 模糊搜索用户
      xzyhModal: false, // 新增用户模态框
      xzyh: {
        sfjsgz:'',
        type:0,
        // 新增用户信息
        username: "", // 用户名
        xm: "123", // 姓名
        xb: "", // 性别
        sfzhm: "", // 身份证号码
        zw: "", //职位
        zzdyqc:''
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      form: {
        dept: "",
        childDept: "",
        name: "",
        gw: "",
        sex: "",
        gangwei: "",
        workNature: "",
        maxAge: "",
        minAge: "",
        jiaojin: "",
        from: "",
        isleave: 0,
        username: "",
        jyknry: "",
        sfzhm: "",
        jrgsStart: "",
        jrgsEnd: "",
        orders:''
      },
      jrgsrq: [],
      depts: [],
      deptdisable: false,
      childdeptdisable: false,
      childDept: [],
      bcxx: {},
      bmxx: {},
      gdxx: {},
      fields:exportFields,
      filedValues:exportFields.map(item => item.value),
      zwxx: {},
      userbm: "",
      usergd: "",
      userbc: [],
      bjyhModal: false, // 编辑用户模态框
      bjyh: {}, // 编辑用户信息
      dictionaryData: [],
      dddbz: [],
      imageurl: "",
      modal: true, // true : 新增用户, false 修改用户
      insertRules: {
        xm: [
          {
            required: true,
            message: "请填写姓名",
            trigger: ["blur", "change"],
          },
        ],
        username: [
          {
            required: true,
            message: "请填写职员工号",
            trigger: ["blur", "change"],
          },
        ],
        // xb: [{
        // 	required: true,
        // 	message: '请选择性别',
        // 	trigger: ['blur', 'change']
        // }],
        sfzhm: [
          {
            required: true,
            message: "请填写身份证号",
            trigger: ["blur", "change"],
          },
          { validator: this.isCardID, trigger: ["blur", "change"] },
        ],
        zjdz: [
          {
            required: true,
            message: "请填写证件地址",
            trigger: ["blur", "change"],
          },
        ],
      },
      addOrUpdateVisible: false,
      exceptionVisible: false,
      blacklistVisible: false,
      batchVisible: false,
      orders:[],
      isIndeterminate: false,
      exportVisible:false,
      checkAll:false,
      fieldList:[],
      showButtons: false // 控制按钮显示与否的变量
    };
  },
  mounted() {
    // this.getgdxx();
    this.getbmxx();
    // this.getbcxx();
    this.getzwxx();
    // this.gettotal();

    this.findDictionary();
    this.getDepts();
    this.getGw();
  },
  methods: {
    getBm(user) {
      var ubmid;
      var bmmc;
      ubmid = user.zzdyqc;
      for (var i = 0; i < this.bmxx.length; i++) {
        if (this.bmxx[i].bmid == ubmid) {
          bmmc = this.bmxx[i].bmmc;
        }
      }
      return bmmc;
    },
    showExportDialog() {
      this.exportVisible = true
    },
    changeIndex() {
      this.currentPage = 1;
    },
    isCardID(rule, value, callback) {
      this.$set(this.xzyh, "csrq", "");
      this.$set(this.xzyh, "xb", "");
      console.log(value);
      if (!/(^\d{15}$)|(^\d{17}(\d|X|x)$)/.test(value)) {
        callback(new Error("身份证长度或格式错误"));
        return;
      }
      //身份证城市
      var aCity = {
        11: "北京",
        12: "天津",
        13: "河北",
        14: "山西",
        15: "内蒙古",
        21: "辽宁",
        22: "吉林",
        23: "黑龙江",
        31: "上海",
        32: "江苏",
        33: "浙江",
        34: "安徽",
        35: "福建",
        36: "江西",
        37: "山东",
        41: "河南",
        42: "湖北",
        43: "湖南",
        44: "广东",
        45: "广西",
        46: "海南",
        50: "重庆",
        51: "四川",
        52: "贵州",
        53: "云南",
        54: "西藏",
        61: "陕西",
        62: "甘肃",
        63: "青海",
        64: "宁夏",
        65: "新疆",
        71: "台湾",
        81: "香港",
        82: "澳门",
        91: "国外",
      };
      if (!aCity[parseInt(value.substr(0, 2))]) {
        callback(new Error("身份证地区非法"));
        return;
      }

      // 出生日期验证
      var sBirthday = (
          value.substr(6, 4) +
          "-" +
          Number(value.substr(10, 2)) +
          "-" +
          Number(value.substr(12, 2))
        ).replace(/-/g, "/"),
        d = new Date(sBirthday);
      if (
        sBirthday !=
        d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate()
      ) {
        callback(new Error("身份证上的出生日期非法"));
        return;
      } else {
        this.$set(this.xzyh, "csrq", this.getFormatDate(d));
      }
      // this.xzyh.csrq = (d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate())}

      // 性别赋值
      this.$set(this.xzyh, "xb", this.getSexByBirthday(value));

      // 身份证号码校验
      var sum = 0,
        weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2],
        codes = "10X98765432";
      for (var i = 0; i < value.length - 1; i++) {
        sum += value[i] * weights[i];
      }
      var last = codes[sum % 11]; //计算出来的最后一位身份证号码
      if (value[value.length - 1].toUpperCase() != last) {
        callback(new Error("身份证号非法"));
        return;
      }

      callback();
    },
    getFormatDate(date) {
      var seperator1 = "-";
      var year = date.getFullYear();
      this.year = year;
      console.log(this.year);
      var month = date.getMonth() + 1;
      this.month = month;
      console.log(this.month);
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },
    // '1' 男; '2' 女
    getSexByBirthday(idCard) {
      let sexStr = ''
      if (parseInt(idCard.slice(-2, -1), 10) % 2 == 1) {
        sexStr = '1'
      } else {
        sexStr = '2'
      }
      return sexStr
    },
    showInsertUser() {
      this.getGw()
      this.usergd = "";
      this.userbc = [];
      this.imageurl = "";
      this.modal = true;
      this.xzyhModal = true;
      //因为rules 效验事件为 change
      //所以在显示添加用户时(所有input都为空) 会触发 效验 导致 全部标红不通过
      //需要主动调用重置方法 resetFields
      this.$nextTick(() => {
        this.xzyh = {};
        this.xzyh.type = 0
        this.$refs["xzyh"].resetFields();
        this.xzyh.sfjsgz = 1
      });
    },
    findDictionary() {
      this.$request({
        method: "get",
        url: "/bjba/yhgl/findDictionary",
      })
        .then((response) => {
          console.log("map:", response.data);
          this.dictionaryData = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectChanged(value) {
      this.dddbz.length = 0;

      this.$request({
        method: "get",
        url: "/bjba/kqtj/getMentForUser2",
        params: {
          fbmid: value,
          userid: this.$store.getters.username,
        },
      })
        .then((response) => {
          this.dddbz = response.data;
          this.getGw()
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectChanged2(value) {
      debugger
      this.currentPage = 1;
      this.childDept = [];
      this.form.childDept = "";
      this.$request({
        method: "get",
        url: "/bjba/kqtj/getMentForUser2",
        params: {
          fbmid: value,
          userid: this.$store.getters.username,
        },
      })
        .then((response) => {
          this.childDept = response.data;

          var zzdyqc = this.$store.getters.user.zzdyqc;
          if (zzdyqc) {
            if (zzdyqc != this.CONST_ZN_BM) {
              var zw = this.$store.getters.user.zw;

              if (zw) {
                if (zw == "02" || zw == "03") {
                  if (this.childDept[0]) {
                    this.form.childDept = this.childDept[0].bmid;
                  }
                }
              }
            }
          }
          this.getUserList();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getParams: function () {
      const {username, currentPage} = this;
      this.form.orders = encodeURI(JSON.stringify(this.orders))
      this.form.page = this.currentPage;
      this.form.pagesize = 10;
      this.form.userid = this.$store.getters.username;
      if (this.jrgsrq && this.jrgsrq.length == 2) {
        this.form.jrgsStart = this.jrgsrq[0];
        this.form.jrgsEnd = this.jrgsrq[1];
      } else {
        this.form.jrgsStart = "";
        this.form.jrgsEnd = "";
      }
    },
    exportExcel: function() {
      var filedLast = this.fields.filter(filed=>{
        return this.fieldList.indexOf(filed.value) !==-1
      })
      if(filedLast && filedLast.length>0) {
        this.getParams();
        this.$refs.fileds.value = JSON.stringify(filedLast)
        this.$refs.exportForm.submit();
      } else {
        this.$message({
          message: '请选择字段',
          type: 'error',
          duration: 1500
        })
        return
      }
    },
    handleCheckAllChange(val) {
      this.fieldList = val ? this.filedValues: [];
      this.isIndeterminate = false;
    },
    handleCheckedItemChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.filedValues.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.fields.length;
    },
    // 分页获取用户列表
    getUserList: function () {
      this.loading = true;
      this.getParams();
      this.$request
        .get("/bjba/yhgl/getUserList", {
          params: this.form,
        })
        .then((res) => {
          const { data } = res;
          console.log("列表数据：", data);
          this.userList = data.data;
          this.total = data.total;

          console.log(this.userList);
          //this.total = data.totalElements
          this.loading = false;
        })
        .catch((err) => {
          this.$message({
            message: "获取用户列表出现异常!",
            type: "error",
            center: true,
            showClose: true,
          });
          this.loading = false;
          console.log(err);
        });
    },
    // 设置列的排序为我们自定义的排序
    handleHeaderClass({ column }) {
      if(!column.multiOrder) column.multiOrder =''
      column.order = column.multiOrder
    },
    handleOrderChange (orderColumn, orderState) {
      let result = this.orders.find(e => e.orderColumn === orderColumn)
      if (result) {
        if(orderState)
        result.orderState = orderState
        else {
          var j =this.orders.indexOf(result);
          if(j !== -1) {
            this.orders.splice(j,1);
          }
        }
      } else {
        this.orders.push({
          orderColumn: orderColumn,
          orderState: orderState
        })
      }
      this.getUserList()
    },
// 上面缺点是只能通过点击表头切换排序状态，点击小三角排序不会触发，处理sort-change事件和点击表头一样
// 列表排序
    handleTableSort({ column }) {
      column.multiOrder = column.order
      this.handleOrderChange(column.property, column.multiOrder)
    },
    getgdxx() {
      let that = this;
      this.$request.get("/bjba/yhgl/getgdxx").then((res) => {
        console.log("gdxx:", res);
        that.gdxx = res.data;
      });
    },
    getbmxx() {
      let that = this;
      this.$request.get("/bjba/yhgl/getbmxx").then((res) => {
        console.log("bmxx:", res);
        that.bmxx = res.data;
      });
    },
    getDepts() {
      let that = this;
      this.$request
        .get("/bjba/kqtj/getFirstMentForUser", {
          params: {
            userid: this.$store.getters.username,
          },
        })
        .then((res) => {
          that.depts = res.data;
          if (this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if (zzdyqc) {
              if (this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
                var zw = this.$store.getters.user.zw;

                if (zw) {
                  if (zw == "01" || zw == "02" || zw == "03") {
                    this.form.dept = that.depts[0].bmid;
                    this.deptdisable = true;
                    if (zw != "01") {
                      this.childdeptdisable = true;
                    }
                    this.selectChanged2(this.form.dept);
                  }
                  this.selectChanged2(this.form.dept);
                }
              } else {
                this.selectChanged2(this.form.dept);
              }
            } else {
              this.selectChanged2(this.form.dept);
            }
          }
        });
    },
    getGw() {
      debugger
      let that = this;
      let ssdd
      for (var i = 0; i < this.bmxx.length; i++) {
        if (this.bmxx[i].bmid == this.xzyh.zzdyqc) {
          ssdd = this.bmxx[i].bmmc;
        }
      }
      debugger
      this.$request
              .get("/bjba/gwgl/all", {
                params: {'ssdd':ssdd}
              })
              .then((res) => {
                console.log("gws:",res.data.data)
                that.gws = res.data.data;
              });
    },
    getbcxx() {
      let that = this;
      this.$request.get("/bjba/yhgl/getbcxx").then((res) => {
        console.log("bcxx:", res);
        that.bcxx = res.data;
      });
    },
    getzwxx() {
      let that = this;
      this.$request.get("/bjba/yhgl/getzwxx").then((res) => {
        console.log("zwxx:", res);
        that.zwxx = res.data;
      });
    },
    // 新增用户信息
    xzyhxx() {
      // 表单校验
      let msg;
      // if (!this.usergd) {
      // 	msg = '请选择岗点!'
      // } else if (!this.userbc) {
      // 	msg = '请选择班次!'
      // }
      if (msg) {
        this.$message({
          message: msg,
          type: "error",
          center: true,
          showClose: true,
        });
        return;
      }

      let that = this;
      this.$refs["xzyh"].validate((valid, object) => {
        console.log("1111111111111111" + object);
        if (!valid) {
          var me;
          for (var message in object) {
            me = object[message];
            break;
          }
          that.$message({
            message: me[0].message,
            type: "error",
            center: true,
            showClose: true,
          });
          return false;
        }
        // 新增用户
        this.$request
          .post("/bjba/yhgl/insertUser", {
            user: this.xzyh,
            imageurl: this.imageurl,
            userbm: this.userbm,
            usergd: "",
            userbc: "",
          })
          .then((res) => {
            const { data } = res;
            console.log(data);
            let msg, type;
            if (data > 0) {
              msg = "新增用户成功!";
              type = "success";
              that.xzyhModal = false;
              that.xzyh = {};
              that.usergd = "";
              that.userbc = [];
              that.$message({
                message: msg,
                type: type,
                center: true,
                showClose: true,
              });
              that.getUserList();
            } else {
              if (data.message) {
                msg = data.message;
                type = "warning";
              } else {
                msg = "新增用户失败!";
                type = "warning";
              }
              that.$message({
                message: msg,
                type: type,
                center: true,
                showClose: true,
              });
            }

          })
          .catch((err) => {
            console.log(err);
            that.$message({
              message: "新增用户出现异常!",
              type: "error",
              center: true,
              showClose: true,
            });
          });
      });
    },
    // 编辑用户信息
    bjyhxx() {
      // 表单校验
      let msg;
      // if (!this.usergd) {
      // 	msg = '请选择岗点!'
      // } else if (!this.userbc) {
      // 	msg = '请选择班次!'
      // }
      if (msg) {
        this.$message({
          message: msg,
          type: "error",
          center: true,
          showClose: true,
        });
        return;
      }
      let that = this;
      this.$refs["xzyh"].validate((valid, object) => {
        console.log("1111111111111111" + object);
        if (!valid) {
          var me;
          for (var message in object) {
            me = object[message];
            break;
          }
          that.$message({
            message: me[0].message,
            type: "error",
            center: true,
            showClose: true,
          });
          return false;
        }
        console.log(this.xzyh.type)
        // 编辑用户
        this.$request
          .post("/bjba/yhgl/updateUser", {
            user: this.xzyh,
            imageurl: this.imageurl,
            usergd: "",
            userbc: "",
          })
          .then((res) => {
            const { data } = res;
            console.log(data);
            let msg, type;
            if (data > 0) {
              msg = "编辑用户成功!";
              type = "success";
              that.bjyhModal = false;
              that.xzyhModal = false;
              this.$message({
                message: msg,
                type: type,
                center: true,
                showClose: true,
              });
              this.getUserList();
            } else {
              if (data.message) {
                msg = data.message;
                type = "warning";
              } else {
                msg = "新增用户失败!";
                type = "warning";
              }
              this.$message({
                message: msg,
                type: type,
                center: true,
                showClose: true,
              });
            }

          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "编辑用户出现异常!",
              type: "error",
              center: true,
              showClose: true,
            });
          });
      });
    },
    // 切换页码
    pageUser(page) {
      this.currentPage = page;
      this.getUserList();
    },
    closepop(close) {
      this.isOpen = close;
      this.isAsOpen = close;
    },
    getKhInfo(row){
      this.isAsOpen = true;
      this.$nextTick(() => {
        this.$refs.fetchNzKhData.fetchTableData(row.id);
      });
    },
    getQsList(row) {
      console.log(row.id);
      //this.yhid = row.id;
      this.isOpen = true;
      this.$nextTick(() => {
        this.$refs.fetchTableData.fetchTableData(row.id);
      });
    },
    setRole(row) {
      console.log(row.id);
      this.addOrUpdateVisible = true;
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(row.id);
      });
    },
    setException(row) {
      console.log(row.id);
      this.exceptionVisible = true;
      this.$nextTick(() => {
        this.$refs.exception.init(row.id);
      });
    },
    setUserBlackList(row) {
      console.log(row.id);
      this.blacklistVisible = true;
      this.$nextTick(() => {
        this.$refs.blacklist.init(row.id);
      });
    },
    setUserIsLogin(row){
      console.log(row.id);
      let that=this;
      let islogin;
      if (row.islogin=='0') islogin='1'
      else islogin='0'
      that.$request
        .get("/bjba/yhgl/updateUserIsLogin", {
          params: {
            userid: row.id,
            islogin: islogin
          },
        })
        .then((res) => {
          console.log(res.data);
          if (res.data==1){
            if(islogin=='1'){
              this.$message({
                message: "禁用成功",
                type: "success",
                center: true,
                showClose: true,
              });
            }else {
              this.$message({
                message: "启用成功",
                type: "success",
                center: true,
                showClose: true,
              });
            }
            this.getUserList();
          }else{
            this.$message({
              message: "变更失败",
              type: "warning",
              center: true,
              showClose: true,
            });
          }
        });
    },
    batchIn() {
      this.batchVisible = true;
      this.$nextTick(() => {
        this.$refs.batch.init(0);
      });
    },
    batchUpdate() {
      this.batchVisible = true;
      this.$nextTick(() => {
        this.$refs.batch.init(1);
      });
    },
    // 编辑用户信息
    bjyhBefore(user) {
      this.getGw()
      let that = this;

      that.modal = false; // 当前拟态框为修改
      that.xzyh = {}; //清除显示数据
      this.xzyh.type = 0
      //that.bjyh = {}

      // this.userbm=''
      that.usergd = "";
      that.userbc = [];
      that.imageurl = "";
      // this.bjyh = user
      that.$request
        .get("/bjba/yhgl/getglxx", {
          params: {
            userid: user.id,
          },
        })
        .then((res) => {
          console.log("编辑：", res.data);
          // this.userbm=res.data.userbm;
          if (res.data.user[0].zzdyqc && res.data.user[0].zzdyqc.length > 0) {
            that.selectChanged(res.data.user[0].zzdyqc);
          }
          that.imageurl = res.data.imageurl;
          // that.usergd = res.data.usergd;
          // that.userbc = res.data.userbc;
          /* 					this.bjyh = res.data.user[0];
										this.bjyhModal = true */
          that.xzyh = { ...res.data.user[0] }; // 对象显示
          this.xzyh.type = 0
          that.xzyhModal = true; //显示弹框
        });
      //this.bjyhModal = true
    },
    // 根据用户ID删除用户
    delUser(user) {
      this.$confirm(`确认删除用户[${user.username}]么?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request
          .post("/bjba/yhgl/removeUser", {
            id: user.id,
          })
          .then((res) => {
            const { data } = res;
            // console.log(data)
            let msg, type;
            if (data > 0) {
              msg = "删除用户成功!";
              type = "success";
            } else {
              msg = "删除用户失败!";
              type = "warning";
            }
            this.$message({
              message: msg,
              type: type,
              center: true,
              showClose: true,
            });
            this.getUserList();
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "删除用户出现异常!",
              type: "error",
              center: true,
              showClose: true,
            });
          });
      });
    },
    //重置密码
    resertPwd(user) {
      this.$confirm(`确认重置用户密码吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$request({
          method: "post",
          url: "/bjba/yhgl/resertPwd",
          params: {
            userid: user.id,
          },
        })
          .then((res) => {
            const { data } = res;
            // console.log(data)
            let msg, type;
            if (data > 0) {
              msg = "重置用户密码成功!";
              type = "success";
            } else {
              msg = "重置用户密码失败!";
              type = "warning";
            }
            this.$message({
              message: msg,
              type: type,
              center: true,
              showClose: true,
            });
            this.getUserList();
          })
          .catch((err) => {
            console.log(err);
            this.$message({
              message: "重置用户密码出现异常!",
              type: "error",
              center: true,
              showClose: true,
            });
          });
      });
    },
    renderHeader (h) {
      return (
              <div class="clearfix">
                <span>操作</span>
                <el-button style="padding:5px;float:right" size="mini"
                           onClick={()=>this.showExportDialog()}>导出</el-button></div>
      )
    },
    showUser(user) {
      this.$router.push({
        path: "/bjba/grzx",
        query: { username: user.username },
      });
    },
    //获取用户列表总条目
    gettotal() {
      this.$request.get("/bjba/yhgl/gettotal").then((res) => {
        console.log(res.data);
        this.total = res.data;
      });
    },
    deleteButtonClicked() {
      this.imageurl = ''
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    httpRequest(data) {
      let _that = this;
      let rd = new FileReader(); // 创建文件读取对象
      let file = data.file;
      rd.readAsDataURL(file); // 文件读取装换为base64类型
      rd.onloadend = function (e) {
        _that.imageurl = e.currentTarget.result; // this指向当前方法onloadend的作用域
        console.log(e.currentTarget.result);
      };
    },
    onInputBlur() {
      let username = this.xzyh.username;
      this.$request({
        method: "post",
        url: "/bjba/yhgl/checkUserRepeat",
        params: { username: username },
      })
        .then((response) => {
          console.log(response);
          if (response.data > 0) {
            this.$message.error("职员工号重复！");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.txImage {
  width: 170px; 
  height: 170px; 
  position: relative;
}
.txImage img {
  width: 100%; 
  height: 100%; 
  border-radius: 6px;
}
.deleteImg {
    width: 100%; /* 设置宽度与目标元素相同 */
    height: 100%; /* 设置高度与目标元素相同 */
    background-color: rgba(0, 0, 0, 0.3);  /* 设置背景色及透明度 */
    position: absolute; /* 设置绝对定位 */
    top: 0; /* 根据需要调整top、left等属性值 */
    left: 0;
    text-align: center;
    line-height: 170px;
    border-radius: 6px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9 !important;
  border-radius: 6px !important;
  cursor: pointer !important;
  position: relative !important;
  overflow: hidden !important;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.smallInput {
  width: 100px;
}
/*.bigInput{*/
/*	width: ;*/
/*}*/
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both
}
 /*.a1 .el-select /deep/.el-input__inner {*/
 /*    background-color: #e4e7ed;*/
 /*    color: black;*/
 /*    border: 1px solid #e43179;*/
 /*  }*/
.a1 .el-select /deep/.el-input__inner {
  background-color: #e4e7ed;
  color: black;
}
</style>
